import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  FormControlLabel,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import ConfirmationModal from "../../Components/Modal/Modal";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import Signifier from "../../Components/Signifier";
import { StyledTextField } from "../../Components/TextField/TextField";
import {
  deleteHereAccount,
  editHereAccount,
} from "../../Services/API/HereDotCom";

function HereDotComPageDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [accountName, setAccountName] = useState(
    location.state === undefined ? "" : location.state.name
  );
  const [isProduction, setIsProduction] = useState(
    location.state === undefined ? "" : location.state.isProduction
  );
  const [appId, setAppId] = useState(
    location.state === undefined ? "" : location.state.appId
  );
  const [appCode, setAppCode] = useState(
    location.state === undefined ? "" : location.state.appCode
  );
  const [notes, setNotes] = useState(
    location.state === undefined ? "" : location.state.notes
  );
  const [deleteQuestion, setDeleteQuestion] = useState("");
  const [processing, setProcessing] = useState(false);
  const [deleted, setDeleted] = useState(false);

  const data = {
    Id: location.state === undefined ? "" : location.state.id,
    Name: accountName,
    AppId: appId,
    AppCode: appCode,
    Notes: notes,
    IsProduction: isProduction,
    ClientHereDotComBetaAccounts: location.state.clientHereDotComBetaAccounts,
    ClientHereDotComProductionAccounts:
      location.state.clientHereDotComProductionAccounts,
  };

  // set the warning message for deleting an account when the linked clients change
  useEffect(() => {
    var question =
      data.ClientHereDotComBetaAccounts.length > 0 ||
      data.ClientHereDotComProductionAccounts.length > 0
        ? "This account is referenced by 1 or more client accounts. Delete this account permanently?"
        : "Delete this account permanently?";

    setDeleteQuestion(question);
  }, [
    data.ClientHereDotComBetaAccounts,
    data.ClientHereDotComProductionAccounts,
  ]);

  const callAPI = (func, responseMessage) => {
    setProcessing(true);
    func.then((res) => {
      console.log(res);
      setShowSignifier(true);
      if (res) {
        setResponseMessage(responseMessage);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    });
  };

  const callDelete = async () => {
    await deleteHereAccount(data).then((response) => {
      if (response) {
        setDeleted(true);
        return true;
      }
    });
    return true;
  };

  if (location.state === undefined) {
    return <Redirect to="/heredotcom" />;
  }

  if (deleted) {
    return <Redirect to="/heredotcom" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Here.com Account</h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={12} item>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Account Name"
                      label="Account Name"
                      variant="standard"
                      fullWidth
                      required
                      value={accountName}
                      onChange={(e) => setAccountName(e.target.value)}
                    />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={isProduction}
                          onChange={(e) => setIsProduction(!isProduction)}
                        />
                      }
                      label="Is Production?"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="App ID"
                      label="App ID"
                      variant="standard"
                      fullWidth
                      required
                      value={appId}
                      onChange={(e) => setAppId(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="App Code"
                      label="App Code"
                      value={appCode}
                      onChange={(e) => setAppCode(e.target.value)}
                      variant="standard"
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Notes"
                      label="Notes"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      variant="standard"
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        callAPI(editHereAccount(data), "Account Saved")
                      }
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <div className={classes.sensitiveSection}>
              <Grid
                item
                xs={12}
                sm={12}
                container
                justifyContent="space-between"
              >
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpenModal(true)}
                >
                  Delete Account
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <ConfirmationModal
          question={deleteQuestion}
          func={() => callAPI(callDelete(), "Account Deleted")}
          closeModal={() => setOpenModal(false)}
          processing={processing}
        />
      </Dialog>
    </>
  );
}

export default HereDotComPageDetailed;
